// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { RbFragmentDoc } from '../ring-builder/rb.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const RingBuilderSetDocument = gql`
    mutation ringBuilderSet($input: RingBuilderInput!, $currency: CurrencyInput!, $country: CountryCode!, $locale: Locale!) {
  ringBuilderSet(input: $input) {
    ringBuilder {
      ...rb
    }
    mountSwitchResult
  }
}
    ${RbFragmentDoc}`;

export function useRingBuilderSetMutation() {
  return Urql.useMutation<SchemaTypes.RingBuilderSetMutation, SchemaTypes.RingBuilderSetMutationVariables>(RingBuilderSetDocument);
};